import getConfig from "config";

import { getCredentials } from "../../firebase/auth";

export default async function constructWsUrlWithAuth(sessionId: string) {
  const { accessToken } = await getCredentials();
  if (!accessToken) return null;

  const wsURL = getConfig().websockets.sessionService.url;

  return `${wsURL}?access-key=${accessToken}&sessionId=${sessionId}`;
}
